import { Component, OnInit, EventEmitter,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { DatePickerGlobalOptions, stateOptionsSample, serviceConstants, formOptions } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { HttpHeaders } from '@angular/common/http';
import { DateObject, Document_Upload_File } from '../../../../models/common';
import { IstSummaryService } from '../../../../services/ist/ist-summary.service';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';

@Component({
  selector: 'app-ist-site-evaluation-update-status',
  templateUrl: './ist-site-evaluation-update-status.component.html',
  styleUrls: ['./ist-site-evaluation-update-status.component.scss']
})
export class IstSiteEvaluationUpdateStatusComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  stateOptions = stateOptionsSample;
  maxDate : Date = new Date() ; 
  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  documaent_attach_list: Document_Upload_File[] = [];
  siteEvaluationUpdateStatusForm: UntypedFormGroup;
  myDate1 = new Date();
  myDate = new Date(this.myDate1.setDate(new Date().getDate() + 1))
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  VisitedFiles = [];
  UploadedFilesList = [];
  content: any;
  heading: string;
  Status: string;
  action: Subject<any> = new Subject();
  ASSIGN_DATE: any;
  staticformFields: any;
  ApplicationID:any;

  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private summaryService: IstSummaryService,
    public datepipe: DatePipe,
    private commonService: CommonService,
    private datashareService: IstDataShareService
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.files = [];
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.getStaticFiledsData('SCR-013');
    this.siteEvaluationUpdateStatusForm = new UntypedFormGroup({
      actualSiteVisitedDate: new UntypedFormControl(null, [Validators.required]),
      documaent_attach_list:new UntypedFormControl(null),
    })
   
    if (this.Status == "2") {
      this.getRecordFprEdit1();
    }   

    //this.criteriaService.getSiteEvaluationCriteria().subscribe(criteria => {
    //  this.formFields = criteria.formFields;
    //});
  }
  getRecordFprEdit1() {
    this.summaryService.getScreenDataForEdit("api/ISTSiteevaluation/Edit?RecordID=" + this.Content.content.id).subscribe(result => {

      this.VisitedFiles = result["StatusFilesList"];
      this.UploadedFilesList = result["FilesList"];
      if (result["Modal"]["ASSIGN_DATE"] != null && result["Modal"]["ASSIGN_DATE"] != undefined) {
        var formd1 = this.datepipe.transform(result["Modal"]["ASSIGN_DATE"], 'dd-MMM-yyyy');
        this.ASSIGN_DATE = formd1;
      }
    });
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  DeleteSavedUpload(item): void {
   
    this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + item).subscribe(result => {
      let code = item;
      this.VisitedFiles = this.VisitedFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    });
  }

  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  uploadchange(event): void {
    if (this.documaent_attach_list == undefined || this.documaent_attach_list == null) {
      this.documaent_attach_list = [];
    }
    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];

    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;   
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) 
      {
        hasUnFormat = true;
      }
      else 
      {
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = this.documaent_attach_list.filter(x=> x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if(hasValue.length > 0)
        {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        } else {
          if (this.staticformFields.ActualDate_CF1.IS_MULTISELECT){
          this.documaent_attach_list.push(uploadFile);
          } else {
            this.documaent_attach_list =[];
            this.documaent_attach_list.push(uploadFile);
          }
        }
      }
    }

    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }

    if(hasMultipleFiles){
      this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + " Please update the unique file name");
    }
  }

  DeleteUpload(file): void {
    let index = this.documaent_attach_list.findIndex(x => x.ID == file);
    this.documaent_attach_list.splice(index, 1);
  }
   full_supdate :DateObject;
  isstatusModified: boolean = false;
  statusupdate(event){
    this.isstatusModified = true
    this.full_supdate = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isstatusModified
    }
  }

  SaveUploadAttachment(): void {
    let Dateofvisited = null;
    if (this.siteEvaluationUpdateStatusForm.valid) {
      Dateofvisited = this.siteEvaluationUpdateStatusForm.controls["actualSiteVisitedDate"].value;
      var formData1 = new Object();
      formData1["DateOfVisited"] = Dateofvisited;
      formData1["DateOfVisitedO"] = this.full_supdate;
      formData1["TransactionID"] = this.Content.content.id;
      formData1["ApplicationId"] = this.Content.content.ApplicationID;
      var formData = new FormData();
      if (this.documaent_attach_list != null && this.documaent_attach_list.length > 0) {
        for (let i = 0; i < this.documaent_attach_list.length; i++) {
          formData.append(("" + (i + 1)), this.documaent_attach_list[i].File);
        }
      }
      formData.append("ScreenData", JSON.stringify(formData1));

      this.summaryService.FilesInsert("api/ISTSiteevaluation/UploadStatus", formData).subscribe(summary => {
        //this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Status has been Updated Successfully.' } } });
        this.commonService.SuccessBanner("Site Evaluation details updated successfully")
      //  this.action.next();
        this.modalRef.close();
      });

    }
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if(this.staticformFields.ActualDate_CF1.IS_MANDATORY){
          this.siteEvaluationUpdateStatusForm.controls["documaent_attach_list"].setValidators([Validators.required]);
          }
      });
  }
}
